module.exports = __webpack_public_path__ + "06362bba1f1248272b56fa39a4878328.svg";